export default __webpack_public_path__ + "static/media/cladding5.ec1e3ddc.jpeg";